<template>
    <article>
        <p>
            The Incidents page displays a list of both ongoing and resolved incidents within the selected time window.
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/incidents.png" />
        </v-card>

        <p>
            Click on the incident ID to view more detailed information:
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/incident_overview.png" />
        </v-card>

        <p>
            The Incident Overview tab displays a Request Latency and Errors Heatmap.
            This chart helps you easily spot patterns or spikes in latency and errors, giving you a quick understanding of the potential cause of the incident.
            A red annotation at the bottom of the chart highlights the incident's timespan.
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/incident_traces.png" />
        </v-card>

        <p>
            The Traces tab shows a list of traces for the affected requests during the incident.
            You can click on any trace to view the flow of that specific request.
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/incident_trace.png" />
        </v-card>

        <h2>AI-based Root Cause Analysis</h2>

        <v-alert color="info" outlined text class="mt-5">
            AI-powered Root Cause Analysis is available only in Coroot Enterprise (from $1 per CPU core/month).
            <a href="https://coroot.com/account" target="_blank" class="font-weight-bold">Start</a> your free trial today.
        </v-alert>

        <p>
            Coroot's AI-based Root Cause Analysis is a powerful feature that automatically analyzes telemetry data, providing you with a
            list of possible causes for the incident in just a few seconds. It's not magic ✨, Coroot uses a model of your entire system,
            acting like an experienced engineer.
            It navigates through the graph of service dependencies to identify issues that are likely related to the incident.
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/incident_rca.png" />
        </v-card>

        <p>
            At Coroot, we believe engineers shouldn't blindly trust any tool.
            That's why Coroot provides evidence for the issues it identifies, making it easy for you to cross-check and verify the findings.
            Simply click on any hypothesis to review the relevant charts.
        </p>

        <v-card max-width="1000">
            <v-img eager src="/static/img/docs/coroot/incident_rca_details.png" />
        </v-card>
    </article>
</template>

<script>

export default {
    components: {}
}
</script>

<style scoped>
</style>
